import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import ConfigDB from "../../config";
import { getwarHouseEntityList } from "../../services/PartsInventory";
import { toast } from "react-toastify";
import { Label, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { useTranslation } from "react-i18next";
import {
  getPartDetailsInternalDetails,
  getPartListWarhouseUpdatedList,
  getPartUpdateLocation,
} from "../../services/PartLocationAssignServices";

const ChangeLocationPart = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const tableLengthList = ConfigDB.data.dataTableLength;

  const [params, setParams] = useState({
    limit: tableLengthList[0],
    page: 1,
    search: "",
    is_reload: false,
  });

  const [modifyQrSearchModal, setmodifyQrSearchModal] = useState(false);
  const [selectedEntities, setSelectedEntities] = useState({
    value: "",
    name: "",
  });
  const [selectedNewEntities, setSelectedNewEntities] = useState({
    value: "",
    name: "",
  });

  const [entityList, setEntityList] = useState([]);
  const [selectBarcodeValue, setSelectBarcodeValue] = useState({
    location_id: "",
    internal_id: "",
  });

  const [partDetails, setPartDetails] = useState([]);

  const [selectedParts, setSelectedParts] = useState([]);

  const handleSelectAll = () => {
    if (selectedParts.length === partDetails.length) {
      setSelectedParts([]);
    } else {
      setSelectedParts([...partDetails]);
    }
  };

  const handleRowCheckboxChange = (part) => {
    const isAlreadySelected = selectedParts.some(
      (item) => item.part_qty_id === part.part_qty_id
    );

    if (isAlreadySelected) {
      setSelectedParts((prev) =>
        prev.filter((item) => item.part_qty_id !== part.part_qty_id)
      );
    } else {
      setSelectedParts((prev) => [...prev, part]);
    }
  };

  const isAllSelected =
    partDetails.length > 0 && selectedParts.length === partDetails.length;

  const handleQrSerachClose = () => {
    setmodifyQrSearchModal(false);
    setSelectBarcodeValue({
      location_id: "",
      internal_id: "",
    });
  };

  const handleSelectChange = (event) => {
    const selectedIndex = event.target.selectedIndex;
    const selectedValue = event.target.value;
    const selectedName = event.target.options[selectedIndex].text;

    setSelectedEntities({ value: selectedValue, name: selectedName });

    setParams((prevParams) => ({
      ...prevParams,
      search_warehouse: parseInt(selectedValue) || "",
    }));
  };

  const handleSelectNewChange = (event) => {
    const selectedIndex = event.target.selectedIndex;
    const selectedValue = event.target.value;
    const selectedName = event.target.options[selectedIndex].text;

    setSelectedNewEntities({ value: selectedValue, name: selectedName });
  };

  useEffect(() => {
    let data = { ...params };
    getwarHouseEntityList(data)
      .then((response) => {
        setEntityList(response.data.data);
      })
      .catch((err) => {
        toast.error(err.message);
      });
  }, [params]);

  const renderOptions = (nodes, level = 0) => {
    return nodes?.map((node) => {
      if (node.children && node.children.length > 0) {
        return (
          <>
            <optgroup
              label={"\u00A0\u00A0".repeat(level) + node.warehouse_name}
              key={node.id}
            />
            {renderOptions(node.children, level + 1)}
          </>
        );
      } else {
        return (
          <option value={node.id} key={node.id}>
            {"\u00A0\u00A0".repeat(level) + node.warehouse_name}
          </option>
        );
      }
    });
  };

  const handleSubmit = async () => {
    let data = {
      limit: 10,
      page: 1,
      search_warehouse: selectedEntities.value,
      search_warehouse_barcode: selectBarcodeValue?.location_id,
    };

    getPartListWarhouseUpdatedList(data)
      .then((response) => {
        toast.success(response.data.message);
        setPartDetails(response.data.data);
        setSelectBarcodeValue({
          location_id: "",
        });
        setmodifyQrSearchModal(false);
      })
      .catch((err) => {
        toast.error(err.response?.data?.message || "An error occurred");
      });
  };

  const handleUpdateSubmit = async () => {
    if (!selectedNewEntities?.value && !selectBarcodeValue?.location_id) {
      toast.error(t("location_id_required"));
      return;
    }

    if (!selectedParts || selectedParts.length === 0) {
      toast.error(t("at_least_one_part_required"));
      return;
    }
    const partListData = selectedParts?.map((item) => ({
      part_id: item.id,
      qty_id: item.part_qty_id,
    }));

    let data = {
      location_id: selectedNewEntities?.value
        ? selectedNewEntities?.value
        : selectBarcodeValue?.location_id,
      part_list: partListData,
    };

    getPartUpdateLocation(data)
      .then((response) => {
        toast.success(response.data.message);
        setSelectBarcodeValue({
          location_id: "",
          internal_id: "",
        });
        setmodifyQrSearchModal(false);
        navigate("/part-location-asssign");
      })
      .catch((err) => {
        toast.error(err.message);
      });
  };

  return (
    <div>
      <div>
        <section className="content-header">
          <div className="container-fluid">
            <div className="row mb-2">
              <div className="col-sm-6"></div>
              <div className="col-sm-6"></div>
            </div>
          </div>
          {/* /.container-fluid */}
        </section>
        <section className="content">
          <div className="container-fluid container-custom-height-new ">
            <div className="row">
              <div className="col-md-12">
                <div className="card fuelCard">
                  <div className="">
                    <div className="">
                      <div className="card-header">
                        <div className="card-title m-0 float-left d-flex">
                          <button
                            type="button"
                            className="btn btn-block btn-primary"
                            onClick={() => navigate("/part-location-asssign")}
                            style={{ width: "100px", marginTop: "10px" }}
                          >{t("back")}<i className="bi bi-arrow-left-short"></i>
                          </button>
                        </div>
                        <div className="card-title m-0 float-right d-flex">
                          <button
                            type="button"
                            className="btn  btn-icon-text mr-2"
                            onClick={() => setmodifyQrSearchModal(true)}
                          >
                            <i className="bi bi-geo-alt-fill"></i>
                            <span className="ms-2">Change Location Part</span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {partDetails?.length > 0 && (
              <div className="card-body">
                <div className="vehicleThBg table-responsive table-responsive-vehicle">
                  <div className="col-md-6">
                    <Label>Warehouse</Label>

                    <select
                      className="form-select"
                      value={selectedNewEntities.value || ""}
                      onChange={handleSelectNewChange}
                    >
                      <option value="" disabled>
                        Select
                      </option>
                      {renderOptions(entityList)}{" "}
                    </select>
                  </div>

                  <table
                    className="table table-bordered rounded-table table-striped table-hover"
                    style={{ marginTop: "10px" }}
                  >
                    <thead>
                      <tr>
                        <th style={{ width: "5%" }}>
                          <input
                            className="my-checkbox-1 form-check-input"
                            type="checkbox"
                            checked={isAllSelected}
                            onChange={handleSelectAll}
                            style={{ marginLeft: "100px" }}
                          />
                        </th>
                        <th style={{ width: "10%" }}>Warehouse Name</th>
                        <th style={{ width: "10%" }}>Part Name</th>
                        <th style={{ width: "10%" }}>Internal Id</th>
                      </tr>
                    </thead>
                    <tbody>
                      {partDetails.map((part, index) => (
                        <tr key={index} style={{ cursor: "pointer" }}>
                          <td>
                            <input
                              className="my-checkbox-1 form-check-input"
                              type="checkbox"
                              checked={selectedParts.some(
                                (item) => item.part_qty_id === part.part_qty_id
                              )}
                              onChange={() => handleRowCheckboxChange(part)}
                              style={{ marginLeft: "100px" }}
                            />
                          </td>
                          <td>
                            {selectedEntities?.name ||
                              selectBarcodeValue?.location_id}
                          </td>
                          <td>
                            {part?.part_name} /{" "}
                            {(part?.vehicle_make_name || "") +
                              " " +
                              (part?.vehicle_model_name || "")}{" "}
                            / {part?.part_code}
                          </td>
                          <td>{part?.parts_internal_id}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  <button
                    type="button"
                    className="btn btn-block btn-primary"
                    onClick={handleUpdateSubmit}
                    style={{ width: "100px", marginTop: "10px" }}
                  >{t("submit")}<i className="bi bi-x-lg"></i>
                  </button>
                </div>
              </div>
            )}
          </div>
        </section>
      </div>

      <Modal isOpen={modifyQrSearchModal}>
        <ModalHeader>{`Serach Warehouse`}</ModalHeader>
        <ModalBody>
          <div className="row">
            <div className="col-md-12">
              <Label>Warehouse</Label>

              <select
                className="form-select"
                value={selectedEntities.value || ""}
                onChange={handleSelectChange}
              >
                <option value="" disabled>
                  Select
                </option>
                {renderOptions(entityList)}{" "}
              </select>
            </div>
            <div className="col-md-12 mt-3">
              <Label>Warehouse Barcode</Label>
              <input
                className="form-control mt-2 input-search"
                type="text"
                value={selectBarcodeValue.location_id}
                onChange={(e) => {
                  const value = e.target.value;
                  setSelectBarcodeValue((prev) => ({
                    ...prev,
                    location_id: value,
                  }));
                }}
                maxLength={50}
                placeholder="Search Warehouse Barcode"
                onClick={(e) => e.stopPropagation()}
              />
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <button
            type="button"
            className="btn btn-block btn-primary"
            onClick={handleQrSerachClose}
            style={{ width: "100px", marginTop: "10px" }}
          >{t("close")}<i className="bi bi-x-lg"></i>
          </button>

          <button
            type="button"
            className="btn btn-block btn-primary"
            onClick={handleSubmit}
            style={{ width: "100px", marginTop: "10px" }}
          >{t("submit")}<i className="bi bi-x-lg"></i>
          </button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default ChangeLocationPart;
